var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.dataFrom.flowNodeId ? _vm.$t("编辑") : _vm.$t("新增"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 700
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("节点")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("节点")
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "auditType",
      label: _vm.$t("操作人类型")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("操作类型"),
      allowClear: ""
    },
    on: {
      change: _vm.getDataFun
    },
    model: {
      value: _vm.dataFrom.auditType,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "auditType", $$v);
      },
      expression: "dataFrom.auditType"
    }
  }, _vm._l(_vm.auditTypeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "userId",
      label: _vm.$t("操作人")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("操作人"),
      allowClear: "",
      disabled: _vm.dataFrom.auditType || _vm.dataFrom.auditType == 0 ? false : true
    },
    model: {
      value: _vm.dataFrom.userId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "userId", $$v);
      },
      expression: "dataFrom.userId"
    }
  }, _vm._l(_vm.operatorList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_c("div", {
      staticStyle: {
        display: "flex"
      }
    }, [_vm._v(" " + _vm._s(item.nickName) + " "), item.roles ? _c("div", [_vm._v("(" + _vm._s(item.roles) + ")")]) : _vm._e()])]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "ccType",
      label: _vm.$t("抄送人类型（选填)")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("抄送人类型"),
      allowClear: ""
    },
    on: {
      change: _vm.getDataFun2
    },
    model: {
      value: _vm.dataFrom.ccType,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "ccType", $$v);
      },
      expression: "dataFrom.ccType"
    }
  }, _vm._l(_vm.auditTypeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "cc2",
      label: _vm.$t("抄送人（选填)")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("操作人抄送人"),
      allowClear: "",
      disabled: _vm.dataFrom.ccType || _vm.dataFrom.ccType == 0 ? false : true,
      mode: "multiple"
    },
    model: {
      value: _vm.cc2,
      callback: function ($$v) {
        _vm.cc2 = $$v;
      },
      expression: "cc2"
    }
  }, _vm._l(_vm.CCList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: String(item.id)
      }
    }, [_c("div", {
      staticStyle: {
        display: "flex"
      }
    }, [_vm._v(" " + _vm._s(item.nickName) + " "), item.roles ? _c("div", [_vm._v("(" + _vm._s(item.roles) + ")")]) : _vm._e()])]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "isSms",
      label: _vm.$t("短信通知")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.dataFrom.isSms,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "isSms", $$v);
      },
      expression: "dataFrom.isSms"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("不通知")))]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("通知")))])], 1)], 1), _vm.mark == "claims" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("驳回至")
    }
  }, [_c("a-radio-group", {
    staticClass: "shu",
    model: {
      value: _vm.dataFrom.goBack,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "goBack", $$v);
      },
      expression: "dataFrom.goBack"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("结束审核流"))), _c("br"), _c("span", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t("结束审核流，审核状态改为未通过")))])]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("退回初始"))), _c("br"), _c("span", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t("审核流退回时，退回至申请人")))])]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("退回上一步骤"))), _c("br"), _c("span", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t("退回至上一节点审核人")))])])], 1)], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };